import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/common/socialMediaLinkListLegacy.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function SocialMediaLinkListLegacy({
	large = false,
	transparentBg = false,
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const linkList = `socialMediaLinkList${onelpsParams.gameId.charAt(0).toUpperCase() + onelpsParams.gameId.slice(1)}`;
	const wrapperClassName = `${styles[linkList]} ${large ? styles.large : null} ${transparentBg ? styles.transparentBg : null}`;

	return (

		<div
			className={wrapperClassName}
			data-testid="socialMediaLinkList">
			{Object.keys(onelpsParams.socialMedia.links).map((socialMediaKey) => {
				return (
					<a
						key={socialMediaKey}
						href={onelpsParams.socialMedia.links[socialMediaKey].link}
						data-testid={onelpsParams.socialMedia.links[socialMediaKey].name}
						className={styles[onelpsParams.socialMedia.links[socialMediaKey].name]}
						target="_blank"
						rel="noreferrer"
					>
					</a>
				);
			})}
		</div>

	);
}

export default SocialMediaLinkListLegacy;

SocialMediaLinkListLegacy.propTypes = {
	large: PropTypes.bool,
	transparentBg: PropTypes.bool,
};